<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="space-between center">

        <!-- Zone gauche: menu + avatar + Titre de page -->
        <div fxFlex="1 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" class="page-heading" *ngIf="pageTitle">
                <mat-icon class="page-icon" *ngIf="pageIcon">{{pageIcon}}</mat-icon>
                <span class="page-title">{{pageTitle}}</span>
            </div>
        </div>

        <!-- Zone droite: cotisation (d'abord) + notifications + mail + user menu -->
        <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="end center" class="right-zone">

            <!-- Cotisation avant l'icône de notification -->
            <div class="px-8 px-md-16" fxHide.lt-md>
                <!-- Affichage pour les users -->
                <a *ngIf="hasRole('user') && !hasRole('super') && !hasRole('ROLE_TRAINEE')" href="{{cotisation_url}}" class="cotisation-label" style="color: inherit;">
                    <p style="font-size: 12px; border-radius: 5px; padding: 0 5px">
                        <span style="margin-right: 5px" class="cotisation-navbar">{{ 'NAVBAR.COTISATION' | translate }}: </span>
                        <span *ngIf="cotisation" style="background-color: #06EA11; padding: 2px 5px; border-radius: 5px; color: white"> {{ 'NAVBAR.UPTODATE' | translate }}</span>
                        <span *ngIf="cotisation === false" style="background-color: #ff3232; padding: 2px 5px; border-radius: 5px; color: white">
                              <span class="wrap">
                                <span class="icon-warning-animate">
                                    {{ 'NAVBAR.NOTUPTODATE' | translate }}
                                </span>
                        </span>
                        </span>
                    </p>
                </a>
                <!-- Affichage pour les stagiaires -->
                <div *ngIf="hasRole('ROLE_TRAINEE')" class="cotisation-label" style="color: inherit;">
                    <p style="font-size: 12px; border-radius: 5px; padding: 0 5px">
                        <span style="margin-right: 5px" class="cotisation-navbar">{{ 'NAVBAR.COTISATION' | translate }}: </span>
                        <span *ngIf="cotisation" style="background-color: #06EA11; padding: 2px 5px; border-radius: 5px; color: white"> {{ 'NAVBAR.UPTODATE' | translate }}</span>
                        <span *ngIf="cotisation === false" style="background-color: #ff3232; padding: 2px 5px; border-radius: 5px; color: white">
                              <span class="wrap">
                                <span class="icon-warning-animate">
                                    {{ 'NAVBAR.NOTUPTODATE' | translate }}
                                </span>
                        </span>
                        </span>
                    </p>
                </div>
        </div>

            <!-- Notifications -->
            <button class="mail-button" type="button" [matMenuTriggerFor]="menu">
                <span class="material-icons">notifications</span>
                <span class="icon-button__badge">{{notificationDto?.count}}</span>
            </button>
            <mat-menu #menu="matMenu" class="my-menu" (menuOpened)="onNotificationsMenuOpened()" xPosition="before" yPosition="below" [overlapTrigger]="false">
                <div class="notif-header" fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="notif-title-header">Notifications</span>
                </div>

                <div class="notif-container" *ngIf="!loadingNotifications; else notifLoading">
                    <button mat-menu-item class="notif-item" (click)="navigateTo(notif, i)" *ngFor="let notif of notificationDto.notifications; let i = index; trackBy: trackByNotificationId">
                        <div class="notif-row">
                            <div class="notification-picture-person">
                                <img *ngIf="notification?.user?.profileImage == '' || user.profileImage == null" class="avatar mr-0 mr-sm-16"
                                src="assets/images/avatars/profile.jpg" alt="">
                                <img *ngIf="notification?.user?.profileImage != '' && user.profileImage != null" class="avatar mr-0 mr-sm-16"
                                    [src]="profileImage" alt="">
                                <span class="material-icons notification-icon">notifications_active</span>
                            </div>
                            <div class="notif-content">
                                <div class="notif-title-line">
                                    <strong class="notif-title" [ngClass]="{'secondary-text': notif.status == 'CONSULTED'}">{{notif?.title}}</strong>
                                    <span *ngIf="notif.status == 'NOTCONSULTED'" class="material-icons notification-visible">fiber_new</span>
                                </div>
                                <p class="notification-items">{{notif?.description}}</p>
                                <p class="notification-items notification-date"><strong>{{calcDays(notif?.dateNotification)}}</strong></p>
                            </div>
                        </div>
                    </button>
                    <div class="empty-state" *ngIf="notificationDto.notifications.length == 0">
                        <span class="material-icons empty-icon">notifications_none</span>
                        <div>Pas de notifications</div>
                    </div>
                </div>
                <ng-template #notifLoading>
                    <div class="notif-loading" fxLayout="row" fxLayoutAlign="center center">
                        <mat-spinner diameter="28"></mat-spinner>
                        <span class="ml-8">Chargement...</span>
                    </div>
                </ng-template>

                <div class="notif-footer" *ngIf="notificationDto.notifications.length > 0">
                    <button mat-stroked-button color="primary" class="notif-action" (click)="markAllAsRead()" [disabled]="(notificationDto?.count||0) === 0">Tout marquer comme lu</button>
                </div>
            </mat-menu>

            <!-- Mail rapide (admin) -->
            <button *ngIf="hasRole('admin')" class="mail-button" (click)="composeMail()" data-title="{{ 'NAVBAR.MAIL' | translate }}">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="material-icons">email</span>
                    <span class="material-icons icon-button__mail">add</span>
                </div>
            </button>

            <!-- Menu utilisateur -->
            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img *ngIf="user.profileImage == '' || user.profileImage == null" class="avatar mr-0 mr-sm-16" src="assets/images/avatars/profile.jpg">
                    <img *ngIf="user.profileImage != '' && user.profileImage != null" class="avatar mr-0 mr-sm-16" [src]="profileImage">
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{user?.firstName}} {{user?.lastName}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>
            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                <button *ngIf="isDualRole && !hasRole('super')" (click)="switchMode()" mat-menu-item class="">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>{{ adminMode ? ('NAVBAR.SWITCH_TO_USER' | translate) : ('NAVBAR.SWITCH_TO_ADMIN' | translate) }}</span>
                </button>
                <button (click)="onLogout()" mat-menu-item class="">
                    <mat-icon>exit_to_app</mat-icon>
                    <span> {{ 'NAVBAR.LOGOUT' | translate }}</span>
                </button>
            </mat-menu>
        </div>

    </div>

</mat-toolbar>